import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { GoogleOAuthProvider } from '@react-oauth/google';
import App from './App';
import { AuthProvider } from './context/AuthContext';
import { CartProvider } from './context/CartContext';
import './index.css';
import { captureSourceAndClean, hashToPath } from './urlCleanup';

// Normal URLs: move an old #/ link to its clean address, then save and strip ad tags (urlCleanup).
hashToPath();
captureSourceAndClean();

// Scrolling over a focused number input changes its value in the browser, which silently edits
// quantities/prices. Blur it instead so the wheel just scrolls the page.
document.addEventListener('wheel', e => {
  const el = document.activeElement;
  if (el && el.type === 'number' && el === e.target) el.blur();
}, { passive: true });

const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || '888978669142-2g9j2jbv42m4bme56m1dbn4e91co6i5s.apps.googleusercontent.com';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      <BrowserRouter>
        <AuthProvider>
          <CartProvider>
            <App />
          </CartProvider>
        </AuthProvider>
      </BrowserRouter>
    </GoogleOAuthProvider>
  </React.StrictMode>
);